import { useMemo } from 'react';

import { BENEFITS } from '@components/pages/SubscribeTest/OfferSelection/constants';

type OfferSlot = unknown;

const useModifiedBenefits = (
  monthlySlot: OfferSlot,
  annualSlot: OfferSlot,
  proSlot: OfferSlot,
  benefits = BENEFITS
) => {
  // Benefit eligibility is an array of booleans in order of Monthly, Annual, Pro
  return useMemo(() => {
    const slots = [monthlySlot, annualSlot, proSlot];
    return benefits.map((benefit) => ({
      ...benefit,
      eligibility: benefit.eligibility.reduce<boolean[]>((acc, perk, index) => {
        if (slots[index]) return [...acc, perk];
        return acc;
      }, []),
    }));
  }, [monthlySlot, annualSlot, proSlot, benefits]);
};

export default useModifiedBenefits;
